import dayjs from 'dayjs';
import 'dayjs/locale/de-ch';
import 'dayjs/locale/en';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import duration from 'dayjs/plugin/duration';
import isLeapYear from 'dayjs/plugin/isLeapYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import isoWeeksInYear from 'dayjs/plugin/isoWeeksInYear';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { LocalesSchema, TLocales } from './Locales';

const currentLocale: TLocales =
  typeof window !== 'undefined'
    ? // @ts-ignore-next-line
      window?.__server__data?.i18n?.locale
      ? // @ts-ignore-next-line
        LocalesSchema.parse(window?.__server__data?.i18n?.locale)
      : 'de'
    : 'de';

switch (currentLocale) {
  case 'de':
    dayjs.locale('de-ch');
    break;
  case 'en':
    dayjs.locale('en');
    break;
}

dayjs.extend(isoWeek);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);
dayjs.extend(quarterOfYear);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isoWeeksInYear);
dayjs.extend(isLeapYear);
dayjs.extend(duration);
dayjs.extend(localizedFormat);

export { isoWeek, isSameOrBefore, quarterOfYear };

export default dayjs;
